import Swiper, {Navigation, Pagination, Mousewheel, Autoplay} from 'swiper';
import 'swiper/css';

const swiperPage = new Swiper('.page-swiper', {
    modules: [Mousewheel],
    slidesPerView: 1,
    direction: 'vertical',
    speed: 1300,
    mousewheel: true,
    allowTouchMove: false,
});


const logo = document.querySelector('.header-logo');
const logoTitle = document.querySelector('.header-logo__title');
const headerMenu = document.querySelector('.header-menu');
const mobileMenu = document.querySelector('.mobile-menu');

if (innerWidth >= 768) {
    swiperPage.on('slideChange', function () {

        const currentSlide = swiperPage.slides[swiperPage.realIndex]

        const fromUp = currentSlide.querySelectorAll('.animate__animated.animate__fadeInUp');
        fromUp.forEach((upItem) => {
            upItem.classList.remove('animate__animated', 'animate__fadeInUp');
            setTimeout(() => {
                upItem.classList.add('animate__animated', 'animate__fadeInUp');
            })
        })

        const fromDown = currentSlide.querySelectorAll('.animate__animated.animate__slideInDown');
        fromDown.forEach((downItem) => {
            downItem.classList.remove('animate__animated', 'animate__slideInDown');
            setTimeout(() => {
                downItem.classList.add('animate__animated', 'animate__slideInDown');
            })
        })

        const fromLeft = currentSlide.querySelectorAll('.animate__animated.animate__fadeInLeft');
        fromLeft.forEach((leftItem) => {
            leftItem.classList.remove('animate__animated', 'animate__fadeInLeft');
            setTimeout(() => {
                leftItem.classList.add('animate__animated', 'animate__fadeInLeft');
            })
        })

        const fromRight = currentSlide.querySelectorAll('.animate__animated.animate__fadeInRight');
        fromRight.forEach((rightItem) => {
            rightItem.classList.remove('animate__animated', 'animate__fadeInRight');
            setTimeout(() => {
                rightItem.classList.add('animate__animated', 'animate__fadeInRight');
            })
        })


        if (this.activeIndex >= 3) {
            logo.classList.add('none')
            headerMenu.classList.add('none')
            mobileMenu.classList.add('none')
        } else {
            logo.classList.remove('none')
            headerMenu.classList.remove('none')
            mobileMenu.classList.remove('none')
        }

        const productSectionMobile1 = document.querySelector('#productSectionMobile-1');
        const productSectionMobile2 = document.querySelector('#productSectionMobile-2');

        if (productSectionMobile1) {
            productSectionMobile1.parentNode.removeChild(productSectionMobile1);
        }
        if (productSectionMobile2) {
            productSectionMobile2.parentNode.removeChild(productSectionMobile2);
        }
    });

} else {
    const productSectionDesktop = document.querySelector('#productSectionDesktop');

    if (productSectionDesktop) {
        productSectionDesktop.parentNode.removeChild(productSectionDesktop);
    }

    if (document.querySelector('#header').nextElementSibling.classList.contains("swiper")) {
        swiperPage.destroy(true, true);
    }
}

const mainSection = document.querySelector('#main-section');
if (mainSection) {
    let swiperMainCount = mainSection.dataset.count;

    if (swiperMainCount <= 1) {
        const swiperMain = new Swiper('.main-swiper', {
            slidesPerView: 1,
            direction: 'vertical',
            allowTouchMove: false,
            loop: false,
        })
    } else {
        const swiperMain = new Swiper('.main-swiper', {
            modules: [Pagination, Autoplay],
            slidesPerView: 1,
            direction: 'vertical',
            allowTouchMove: false,
            pagination: {
                el: ".main-pagination",
                clickable: true,
            },
            autoplay: {
                delay: 5000,
            },
            loop: true,
            speed: 1800,
        });
    }
}

const swiperGallery = new Swiper('.gallery-swiper', {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 3,
    spaceBetween: 0,
    loop: true,
    pagination: {
        el: ".gallery-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
    },
    navigation: {
        nextEl: ".gallery-button-next",
        prevEl: ".gallery-button-prev",
        clickable: true,
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        1200: {
            slidesPerView: 3,
        },
        1920: {
            slidesPerView: 4,
        },
    },
    autoplay: {
        delay: 4000,
    },
    speed: 1800,
});

const swiperProduct1 = new Swiper('.product-1-swiper', {
    modules: [Pagination, Autoplay, Navigation],
    slidesPerView: 1,
    loop: true,
    pagination: {
        el: ".product-1-swiper-pagination",
        clickable: true,
    },
    autoplay: {
        delay: 4000,
    },
    speed: 1400,
});

const swiperProductFull = new Swiper('.product-2-swiper', {
    modules: [Pagination, Navigation, Autoplay],
    slidesPerView: 1,
    loop: true,
    pagination: {
        el: ".product-2-swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
    },
    navigation: {
        nextEl: ".product-2-swiper-button-next",
        prevEl: ".product-2-swiper-button-prev",
        clickable: true,
    },
    autoplay: {
        delay: 4000,
    },
    speed: 1800,
});
